var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEditIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Edit_icon",
    transform: "translate(1.625 1.676)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3009",
    "data-name": "Rectangle 3009",
    width: 16,
    height: 16,
    transform: "translate(-1.625 -1.676)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6700",
    "data-name": "Path 6700",
    d: "M-3868.771-673.676l-.5-2.126a1.808,1.808,0,0,1,.355-1.562l5.8-7.217.012-.014a2.205,2.205,0,0,1,1.693-.783,2.225,2.225,0,0,1,1.38.48l1.027.794a2.141,2.141,0,0,1,.945,1.318,2.107,2.107,0,0,1-.274,1.629c-.019.03-.031.049-1.161,1.458-.012.018-.025.037-.039.054a.83.83,0,0,1-.064.074c-.846,1.055-2.269,2.824-4.665,5.805a1.88,1.88,0,0,1-1.447.7l-2.24.028h-.01A.83.83,0,0,1-3868.771-673.676Zm1.147-2.655a.171.171,0,0,0-.035.149l.352,1.481,1.576-.02a.217.217,0,0,0,.168-.078l4.188-5.21-2.04-1.557Zm7.285-4.969.613-.765a.475.475,0,0,0,.047-.341.5.5,0,0,0-.232-.313.682.682,0,0,1-.08-.055l-1.073-.829-.006,0a.546.546,0,0,0-.344-.12.544.544,0,0,0-.414.186l-.55.684Zm-1.535,8.26a.829.829,0,0,1-.831-.826.829.829,0,0,1,.831-.826h4.468a.829.829,0,0,1,.831.826.829.829,0,0,1-.831.826Z",
    transform: "translate(3869.326 685.378)",
    fill: "#171c28"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit_icon.d71a2804.svg";
export { ForwardRef as ReactComponent };